export default async function format(value, _options) {
  let formattedValue = value;

  formattedValue = `${(value / 100).toFixed(2)}%`;

  return formattedValue;
}
